import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, exhaustMap, map, of, switchMap, tap } from 'rxjs';
import { authActions } from './auth.actions';
import { LocalStorageJwtService } from '@core/services/localstoragejwt.service';
import { AuthService } from '../services/auth.service';
import {
    LocalStorageService,
    LOCAL_STORAGE_KEY,
} from '@core/services/localstorage.service';
import { ToastrService } from 'ngx-toastr';
import { handlingErrMsg } from '@constants/common.constant';

@Injectable()
export class RootEffects {
    public login$ = createEffect(
        (
            authService = inject(AuthService),
            toastrService = inject(ToastrService)
        ) => {
            return this.actions$.pipe(
                ofType(authActions.login),
                exhaustMap((data) =>
                    authService.login(data).pipe(
                        map((response) => {
                            toastrService.success('Đăng nhập thành công!');
                            return authActions.loginsuccess({
                                user: response.Data,
                            });
                        }),
                        catchError((responseError) => {
                            toastrService.error(
                                handlingErrMsg(responseError),
                                'Có lỗi xảy ra',
                                { enableHtml: true }
                            );
                            return of(authActions.loginfailure(responseError));
                        })
                    )
                )
            );
        },
        { functional: true, dispatch: true }
    );

    public signup$ = createEffect(
        (
            authService = inject(AuthService),
            toastrService = inject(ToastrService),
            router = inject(Router)
        ) => {
            return this.actions$.pipe(
                ofType(authActions.register),
                exhaustMap((data) =>
                    authService.signUp(data).pipe(
                        map((response) => {
                            router.navigateByUrl('/sign-in');
                            toastrService.success(
                                'Regist account successfully!'
                            );
                            return authActions.registersuccess({
                                user: response.Data,
                            });
                        }),
                        catchError((responseError) => {
                            toastrService.error(
                                handlingErrMsg(responseError),
                                'Có lỗi xảy ra',
                                { enableHtml: true }
                            );
                            return of(
                                authActions.registerfailure(responseError)
                            );
                        })
                    )
                )
            );
        },
        { functional: true, dispatch: true }
    );

    public loginOrRegisterSuccess$ = createEffect(
        (
            actions$ = inject(Actions),
            localStorageJwtService = inject(LocalStorageJwtService),
            router = inject(Router),
            localService = inject(LocalStorageService)
        ) => {
            return actions$.pipe(
                ofType(authActions.loginsuccess),
                tap((action) => {
                    localStorageJwtService.setItem(action.user.Token);
                    localService.setObject(LOCAL_STORAGE_KEY.USER, action.user);
                    router.navigateByUrl('/dashboard');
                })
            );
        },
        { functional: true, dispatch: false }
    );

    public logout$ = createEffect(
        (
            actions$ = inject(Actions),
            authService = inject(AuthService),
            router = inject(Router),
            localStorageJwtService = inject(LocalStorageJwtService),
            localStorage = inject(LocalStorageService)
        ) => {
            return actions$.pipe(
                ofType(authActions.logout),
                switchMap(() => authService.logout()),
                tap(() => {
                    router.navigateByUrl('/sign-in');
                    localStorageJwtService.removeItem();
                    localStorage.clear();
                }),
                catchError((responseError) => {
                    return of(authActions.logoutfailure(responseError));
                })
            );
        },
        { functional: true, dispatch: true }
    );

    constructor(private actions$: Actions) {}
}
